import axios from "axios";
const BASE_URL = 'https://api.themoviedb.org/3';
const API_KEY = 'e78d300b41622292faa3e76f64eb27d7';
const rest = axios.create({
    baseURL: BASE_URL,
    params: { api_key: API_KEY }
});
export var Tmdb;
(function (Tmdb) {
    Tmdb.api = {
        getConfiguration: () => rest.get('/configuration').then(response => {
            return configuration = response.data;
        }),
        searchMovie: (request) => rest.get('/search/movie', { params: request }).then(response => response.data),
        getMovieGenres: (language) => rest.get('/genre/movie/list', { params: { language } }).then(response => response.data),
    };
    let configuration = null;
    Tmdb.toImageUrl = (path, size = 'w500') => {
        return path && configuration.images.secure_base_url + '/' + size + path;
    };
})(Tmdb || (Tmdb = {}));
